import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../App.css';
import './frontpage.css';
import Sidebar from '../../Sidebar';
import { Link } from 'react-router-dom'; 
import Seo from "../../Seo";
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
              break;
          }
      }
  }
  return cookieValue;
}

function Frontpage() {
  const [items, setItems] = useState([]);
  const csrftoken = getCookie('csrftoken');

  useEffect(() => {
    axios.get('/backend/home.php', {
        headers: {
            'Custom-type': 'home',
            'Content-Type': 'application/json',
            'X-CSRFToken': csrftoken,
        }
    })
    .then(response => {
        setItems(response.data);
    })
    .catch(error => {
        console.error('Es gab einen Fehler beim Abrufen der Daten:', error);
    });
}, []);

  useEffect(() => {
    LanguageChange();
  }, [items]);// Dieser Effekt wird nur ausgeführt, wenn sich `items` ändert

  const LanguageChange = () => {
    if (items.length > 0) {
      const languageIndex = sessionStorage.getItem("language_index");
      const isEnglish = languageIndex != null && languageIndex == 1;
  
      const texts = ["text1", "e_text1", "e_text2", "e_text3"];
      const topics = ["", "e_topic1", "e_topic2", "e_topic3"];
     document.getElementById('topic_header').innerText="Finn Mikoschek";
     document.getElementById('first_header').innerText=isEnglish ?"Home":"Startseite";
     document.getElementsByName('show-more').forEach((element)=>{
      element.innerText=isEnglish ? "Show more":"Mehr anzeigen"
     });
    document.getElementById('text_header').innerText=isEnglish ? "Custom software solutions for web, iOS and Android.":"Individuelle Softwarelösungen für Web, iOS und Android.";
      texts.forEach((id, index) => {
        const element = document.getElementById(id);
        const topic_element = document.getElementById(topics[index]);
        if (element && items[index]) {
          element.innerHTML = isEnglish ? items[index].en_text : items[index].de_text;
        }
        if(topic_element && items[index]){
            topic_element.innerHTML = isEnglish ? items[index].en_topic : items[index].de_topic;
        }
      });
    } else {
    
    }
  };

  return (
    <>
     <Seo
        title="Finn Mikoschek – Softwareentwickler (Web & Apps)"
        description="Softwareentwicklung für Web und Apps. Leistungen, Projekte und Kontakt."
      />
    <div><Sidebar onLanguageChange={LanguageChange}/> 
    <div class="App-header">
    <div class="img_header"><h1 id='topic_header'>Finn Mikoschek</h1>
    <p id='text_header'>Custom software solutions for web, iOS and Android.</p><img src="/images/header_2.webp"></img></div>
      <div class="text_container">
      <div class="text_container_data">
        <h2 id="first_header">Startseite</h2>
          <a id="text1">Willkommen! Ich bin Finn Mikoschek, selbstständiger Softwareentwickler mit Schwerpunkt auf Web- und App-Entwicklung. Ich entwickle individuelle Softwarelösungen für Unternehmen und Privatpersonen – von performanten Webanwendungen bis hin zu mobilen Apps für iOS und Android.

Neben Kundenprojekten habe ich mehrere eigene Anwendungen realisiert, darunter das Quiz-Spiel „Vulpio“ sowie weitere mobile Apps, die im App Store und bei Google Play veröffentlicht sind. Mein Fokus liegt auf sauberer Architektur, skalierbarer Entwicklung und nachhaltiger Performance. </a>
          <div class="services_preview_outercontainer">
          <Link to='/services/application-software' className="services_preview_innercontainer">
              
              <img src="/images/frontpage_1.webp"></img>
              <div class="inner_text">
                <h2 name="header2" id="e_topic1">Individuelle Softwarelösungen</h2>
                <a id="e_text1">
                Ich entwickle maßgeschneiderte Software, die exakt zu den Abläufen und Anforderungen Ihres Unternehmens passt. Plattformübergreifend, flexibel und sicher – für kleine und mittelständische Betriebe, die eine Lösung statt Standard suchen.</a>
                <h3 name='show-more'>Individuelle Lösungen entdecken</h3>
              </div>
              </Link>
              <Link to='/services/web-development' className="services_preview_innercontainer">
              <img src="/images/frontpage_2.webp"></img><div class="inner_text">
              <h2 name="header2" id="e_topic2">Webentwicklung & Firmen-Webseiten</h2>
              <a id="e_text2">Ihre Website ist das digitale Gesicht Ihres Unternehmens. Ich erstelle moderne Firmen-Webseiten und leistungsstarke Web-Anwendungen, die professionell aussehen, auf allen Geräten funktionieren und Ihre Prozesse optimal unterstützen.</a>
              <h3 name='show-more'>Mehr über Webentwicklung erfahren</h3>
              </div>
              
              </Link>
              <Link to='/products' className="services_preview_innercontainer">
              <img src="/images/frontpage_3.webp"></img><div class="inner_text">
              <h2 name="header2" id="e_topic3">Eigene Apps</h2>
              <a id="e_text3">Neben maßgeschneiderter Software habe ich auch eigene Apps für Android und iOS entwickelt. Hier finden Sie eine Übersicht aller Apps.</a>
              <h3 name='show-more'>Entwickelte Apps anzeigen</h3>
              </div>
              </Link>
          </div>
      </div>
      </div>
    </div>
    </div>
    </>
  );
}

export default Frontpage;
